import PropTypes from 'prop-types';

// project imports
import LogoSection from '../LogoSection';
import ProfileSection from './ProfileSection';
import TimezoneSelector from './TimezoneSelector';
import SessionWarningIndicator from 'ui-components/SessionWarningBanner';

// assets
import { IconMenu2 } from '@tabler/icons-react';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
    return (
        <header className="gd-topbar">
            <button type="button" className="gd-topbar__toggle" onClick={handleLeftDrawerToggle} aria-label="Toggle menu">
                <IconMenu2 stroke={1.5} size={20} />
            </button>
            <LogoSection />
            <div className="gd-topbar__spacer" />
            <SessionWarningIndicator />
            <TimezoneSelector />
            <ProfileSection />
        </header>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
